<template>
    <div class="culture">
        <section>
            <div class="flex-item ">
                <img src="../../assets/images/cul1.png" />
            </div>
            <div class="flex-item">
                <h2 class="wow animate__fadeInRight">企业战略</h2>
                <p>自助开发、精益求精、成为光纤通信和光纤传感领域的主流供应商</p>
            </div>
        </section>
        <section>
            <div class="flex-item ">
                <img src="../../assets/images/cul2.png" />
            </div>
            <div class="flex-item">
                <h2 class="wow animate__fadeInLeft">企业使命</h2>
                <p>为客户提供低成本、高品质的产品和技术解决方案</p>
            </div>
        </section>
        <section>
            <div class="flex-item ">
                <img src="../../assets/images/cul3.png" />
            </div>
            <div class="flex-item">
                <h2 class="wow animate__fadeInRight">企业精神</h2>
                <p>诚信、高效、拼搏、创新</p>
            </div>
        </section>
        <section>
            <div class="flex-item">
                <img src="../../assets/images/cul4.png" />
            </div>
            <div class="flex-item">
                <h2 class="wow animate__fadeInLeft">企业价值观</h2>
                <p>不断提升自我、努力向上、创造非凡</p>
            </div>
        </section>
        <section>
            <div class="flex-item">
                <img src="../../assets/images/cul5.png" />
            </div>
            <div class="flex-item">
                <h2 class="wow animate__fadeInRight">企业宗旨</h2>
                <p>一切是为了员工创造美好生活和才智挥扬</p>
            </div>
        </section>
    </div>
</template>
<script>
import WOW from "wow.js";
export default {
    name: "Culture",
    mounted() {
        this.$store.commit("changeTab", 1);
        const wow = new WOW({
            boxClass: "wow", // default
            animateClass: "animate__animated", // default
            offset: 0, // default
            mobile: true, // default
            live: true // default
        });
        wow.init();
    }
};
</script>
<style lang="scss" scoped>
section {
    width: 100%;
    display: flex;
    align-items: stretch;
    &:nth-child(2n) {
        flex-direction: row-reverse;
    }
    .flex-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        h2 {
            color: #1a98d7;
            letter-spacing: 1px;
            margin-bottom: 15px;
        }
        p {
            color: #4c4c4c;
            font-size: 20px;
        }
        img {
            vertical-align: top;
            width: 100%;
        }
    }
}
</style>
